<template>
  <div id="app-vue">
    <TabMenu :model="items" /> 
    <div class="progress-spinner" v-if="this.$store.state.spinnerON" >
      <ProgressSpinner />
    </div>
    <router-view />
  </div>

</template>

<script>
import ProgressSpinner from 'primevue/progressspinner';

export default {
  name: "app",
  components: { ProgressSpinner },
  data() {
    return {
      loginOK: false,
      passValue: null,
      items: [
        { label: "Home", icon: "pi pi-home", to: "/" },
        { label: "Annuario", icon: "pi pi-calendar", to: "/annuario", },
        { label: "Accoglienza", icon: "pi pi-users", to: "/accoglienza", },
        { label: "Altro", icon: "pi pi-star", to: "/altro", },
      ],
    };
  },
  created() {
      var localPass = localStorage.getItem('password');
      if ( localPass ) {
        this.$store.commit( 'SET_LOGIN_ACTIF', true )
      }
  },
}
</script>

<style>
#app-vue {
  background-color: white;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  max-width: 500px;
  min-height: 100vh;
  margin: 0 auto;
}
.mdc-bottom-navigation {
  width: 500px;
  text-align: center;
  margin: 0 auto;
}
.p-tabmenu {
  position: fixed;
  width: 100%;
  bottom: 0;
  max-width: 500px;
}
.progress-spinner {
    position: fixed;
    z-index: 999;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}
</style>